/* ============================================================
   TOTEALLY — offer engine
   Safe against multiple script executions.
   Every binder marks its element, so re-running boot() is a no-op.
   ============================================================ */
(function () {
  'use strict';

  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }

  /* claim(el, key) returns false if this element was already handled */
  function claim(el, key) {
    if (!el) return false;
    var k = 'ta' + key;
    if (el.dataset[k]) return false;
    el.dataset[k] = '1';
    return true;
  }

  /* ============ OFFER ============ */
  function Offer(root) {
    this.root = root;
    this.data = JSON.parse(root.querySelector('[data-ta-offer-data]').textContent);
    this.tiers = [].slice.call(root.querySelectorAll('[data-ta-tier]'));
    this.bumpsEl = root.querySelector('[data-ta-bumps]');
    this.bumps = [].slice.call(root.querySelectorAll('[data-ta-bump]'));
    this.btn = root.querySelector('[data-ta-atc]');
    this.rows = root.querySelector('[data-ta-stack-rows]');
    this.total_ = root.querySelector('[data-ta-stack-total]');
    this.picks = {};
    this.busy = false;
    this.tier = this.data.defaultTier || 'duo';
    this.init();
  }

  Offer.prototype.init = function () {
    var self = this;

    /* tier cards */
    this.tiers.forEach(function (el) {
      var key = el.dataset.taTier;
      self.picks[key] = [];
      el.querySelectorAll('[data-ta-pick]').forEach(function (g, i) {
        var on = g.querySelector('.is-on');
        self.picks[key][i] = on ? on.dataset.taSw : null;
      });
      if (!claim(el, 'BoundTier')) return;
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-ta-sw]')) return;
        if (e.target.closest('[data-ta-bump]')) return;
        self.select(key);
      });
    });

    /* color swatches */
    this.root.querySelectorAll('[data-ta-sw]').forEach(function (sw) {
      if (!claim(sw, 'BoundSw')) return;
      sw.addEventListener('click', function (e) {
        e.stopPropagation();
        var g = sw.closest('[data-ta-pick]');
        if (!g) return;
        g.querySelectorAll('[data-ta-sw]').forEach(function (s) { s.classList.remove('is-on'); });
        sw.classList.add('is-on');
        g.classList.remove('ta-pick--err');
        var lab = g.querySelector('[data-ta-swlabel]');
        if (lab) lab.textContent = sw.dataset.taSw;
        var t = sw.closest('[data-ta-tier]');
        if (t) {
          self.picks[t.dataset.taTier][parseInt(g.dataset.taPick, 10)] = sw.dataset.taSw;
          self.select(t.dataset.taTier);
        }
      });
    });

    /* order bumps */
    this.bumps.forEach(function (b) {
      if (!claim(b, 'BoundBump')) return;
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        b.classList.toggle('is-on');
        self.render();
      });
    });

    /* checkout button */
    if (this.btn && claim(this.btn, 'BoundAtc')) {
      this.btn.addEventListener('click', function () { self.checkout(); });
    }

    this.select(this.tier);
  };

  Offer.prototype.select = function (key) {
    this.tier = key;
    var self = this;
    var cfg = this.data.tiers[key] || {};
    var hide = cfg.hideBumps || [];
    var free = cfg.freeBumps || [];

    this.bumps.forEach(function (b) {
      var k = b.dataset.taBumpKey || '';
      var off = hide.indexOf(k) > -1 || free.indexOf(k) > -1;
      b.style.display = off ? 'none' : '';
      b.classList.toggle('is-hidden', off);
      if (off) b.classList.remove('is-on');
    });

    this.tiers.forEach(function (el) {
      var on = el.dataset.taTier === key;
      el.classList.toggle('is-on', on);
      el.classList.toggle('has-bumps', on && !!self.bumpsEl);
      if (on && self.bumpsEl && el.parentNode) el.insertAdjacentElement('afterend', self.bumpsEl);
      /* clear any validation highlight when leaving a tier */
      if (!on) {
        el.querySelectorAll('.ta-pick--err').forEach(function (g) { g.classList.remove('ta-pick--err'); });
      }
    });

    this.render();
  };

  Offer.prototype.lines = function () {
    var t = this.data.tiers[this.tier];
    if (!t || !this.data.colors) return [];
    var picks = (this.picks[this.tier] || []).slice(0, t.units);

    var count = {};
    picks.forEach(function (c) { if (c) count[c] = (count[c] || 0) + 1; });

    var map = this.data.colors, out = [];
    for (var color in count) {
      if (map[color] && map[color][t.key]) {
        out.push({ id: map[color][t.key], quantity: count[color] });
      }
    }
    if (t.bonus) out.push({ id: t.bonus, quantity: 1 });
    return out;
  };

  Offer.prototype.addons = function () {
    return this.bumps
      .filter(function (b) { return b.classList.contains('is-on') && !b.classList.contains('is-hidden'); })
      .map(function (b) { return { id: +b.dataset.taBump, price: +b.dataset.taPrice, title: b.dataset.taTitle }; });
  };

  Offer.prototype.sum = function () {
    var t = this.data.tiers[this.tier];
    var total = t ? t.price : 0;
    this.addons().forEach(function (a) { total += a.price; });
    return total;
  };

  Offer.prototype.render = function () {
    var t = this.data.tiers[this.tier], total = this.sum();

    if (this.btn) this.btn.textContent = this.data.ctaLabel || 'Check-out';

    if (this.rows && t) {
      var h = '<div class="ta-stack__row"><span>' + t.stackLabel + '</span><span>' + money(t.compare) + ' value</span></div>';
      (t.freebies || []).forEach(function (f) {
        h += '<div class="ta-stack__row"><span>' + f.label + '</span><span class="ta-stack__free">FREE' + (f.was ? ' <s>' + f.was + '</s>' : '') + '</span></div>';
      });
      this.addons().forEach(function (a) {
        h += '<div class="ta-stack__row"><span>' + a.title + '</span><span>' + money(a.price) + '</span></div>';
      });
      this.rows.innerHTML = h;
    }
    if (this.total_) this.total_.textContent = money(total);

    var s = document.querySelector('[data-ta-sticky]');
    if (s && t) {
      var n = s.querySelector('[data-ta-sticky-name]');
      var p = s.querySelector('[data-ta-sticky-price]');
      var w = s.querySelector('[data-ta-sticky-was]');
      var o = s.querySelector('[data-ta-sticky-off]');
      var pct = t.compare ? Math.round((t.compare - t.price) / t.compare * 100) : 0;
      if (n) n.textContent = t.name || t.stackLabel;
      if (p) p.textContent = money(total);
      if (w) w.textContent = money(t.compare);
      if (o) { o.textContent = pct + '% OFF'; o.style.display = pct > 0 ? 'inline-block' : 'none'; }
    }
  };

  /* every unit needs a colour before checkout is allowed */
  Offer.prototype.validate = function () {
    var tierEl = this.root.querySelector('[data-ta-tier="' + this.tier + '"]');
    if (!tierEl) return true;

    var groups = [].slice.call(tierEl.querySelectorAll('[data-ta-pick]'));
    var first = null;

    groups.forEach(function (g) {
      if (g.querySelector('[data-ta-sw].is-on')) { g.classList.remove('ta-pick--err'); return; }
      g.classList.remove('ta-pick--err');
      void g.offsetWidth;                 /* restart the animation */
      g.classList.add('ta-pick--err');
      if (!first) first = g;
    });

    if (!first) return true;

    first.scrollIntoView({ behavior: 'smooth', block: 'center' });

    var b = this.btn;
    if (b) {
      var label = this.data.ctaLabel || 'Check-out';
      b.classList.remove('ta-btn--shake');
      void b.offsetWidth;
      b.classList.add('ta-btn--shake');
      b.textContent = 'Pick a color for each insert';
      clearTimeout(this._errT);
      this._errT = setTimeout(function () {
        b.classList.remove('ta-btn--shake');
        b.textContent = label;
      }, 2400);
    }

    return false;
  };

  /* no request: the permalink replaces the cart and loads checkout directly */
  Offer.prototype.checkout = function () {
    if (this.busy) return;
    if (!this.validate()) return;

    var items = this.lines();
    if (!items.length) return;
    this.addons().forEach(function (a) { items.push({ id: a.id, quantity: 1 }); });

    var parts = items.map(function (i) { return i.id + ':' + i.quantity; });
    this.busy = true;
    this.btn.disabled = true;
    this.btn.textContent = 'One moment...';
    window.location.href = '/cart/' + parts.join(',') + '?checkout';
  };

  /* ============ GALLERY ============ */
  function gallery(root) {
    if (!claim(root, 'BoundGal')) return;
    var track = root.querySelector('[data-ta-gal-track]');
    var dots = [].slice.call(root.querySelectorAll('[data-ta-gal-dot]'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-ta-gal-thumb]'));
    if (!track) return;
    function mark(i) {
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      thumbs.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
    }
    track.addEventListener('scroll', function () {
      mark(Math.round(track.scrollLeft / track.clientWidth));
    }, { passive: true });
    dots.concat(thumbs).forEach(function (el) {
      el.addEventListener('click', function () {
        var i = +el.dataset.i;
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        mark(i);
      });
    });
  }

  /* ============ BEFORE / AFTER SLIDER ============ */
  function baSlider(el) {
    if (!claim(el, 'BoundBaw')) return;
    var right = el.querySelector('[data-ta-baw-r]');
    var handle = el.querySelector('[data-ta-baw-handle]');
    if (!right || !handle) return;
    var drag = false;
    function set(x) {
      var r = el.getBoundingClientRect();
      var p = Math.max(4, Math.min(96, ((x - r.left) / r.width) * 100));
      right.style.clipPath = 'inset(0 0 0 ' + p + '%)';
      handle.style.left = p + '%';
    }
    function down(e) { drag = true; set(e.touches ? e.touches[0].clientX : e.clientX); }
    function move(e) { if (!drag) return; if (e.touches) { set(e.touches[0].clientX); } else { e.preventDefault(); set(e.clientX); } }
    function up() { drag = false; }
    el.addEventListener('mousedown', down);
    el.addEventListener('touchstart', down, { passive: true });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup', up);
    window.addEventListener('touchend', up);
    el.addEventListener('click', function (e) { if (!drag) set(e.clientX); });
  }

  /* ============ ACCORDION ============ */
  function accordions() {
    document.querySelectorAll('[data-ta-acc-q]').forEach(function (q) {
      if (!claim(q, 'BoundAcc')) return;
      q.addEventListener('click', function () {
        var item = q.closest('[data-ta-acc-item]');
        if (item) item.classList.toggle('is-on');
      });
    });
  }

  /* ============ STICKY BAR ============ */
  function sticky() {
    var bar = document.querySelector('[data-ta-sticky]');
    var atc = document.querySelector('[data-ta-atc]');
    if (!bar || !atc) return;
    if (!claim(bar, 'BoundSticky')) return;

    function update() {
      if (window.innerWidth >= 750) { bar.classList.remove('is-on'); return; }
      bar.classList.toggle('is-on', atc.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    var btn = bar.querySelector('[data-ta-sticky-btn]');
    if (btn) btn.addEventListener('click', function () { atc.click(); });
  }

  /* ============ ANNOUNCEMENT ROTATOR ============ */
  function announcement() {
    var w = document.querySelector('[data-ta-ann]');
    if (!w) return;
    if (!claim(w, 'BoundAnn')) return;
    var it = [].slice.call(w.querySelectorAll('.ta-ann__item'));
    if (it.length < 2) return;
    var i = 0;
    setInterval(function () {
      it[i].classList.remove('is-on');
      i = (i + 1) % it.length;
      it[i].classList.add('is-on');
    }, 4200);
  }

  /* ============ LOW STOCK ESCALATION ============ */
  function lowStock() {
    document.querySelectorAll('[data-ta-lowstock]').forEach(function (el) {
      if (!claim(el, 'BoundLow')) return;
      var after = el.getAttribute('data-ta-lowstock-after') || el.getAttribute('data-ta-late') || '';
      var raw = el.getAttribute('data-ta-lowstock-delay') || el.getAttribute('data-ta-delay') || '10';
      var delay = (parseInt(raw, 10) || 10) * 1000;
      if (!after) return;
      setTimeout(function () {
        el.textContent = after;
        el.classList.add('is-late');
        el.classList.add('is-critical');
      }, delay);
    });
  }

  /* ============ DRAWER ============ */
  function drawer() {
    var b = document.querySelector('[data-ta-burger]');
    var d = document.querySelector('[data-ta-drawer]');
    if (!b || !d) return;
    if (!claim(b, 'BoundDrawer')) return;

    function close() {
      d.classList.remove('is-on');
      b.classList.remove('is-on');
      b.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    b.addEventListener('click', function () {
      var on = d.classList.toggle('is-on');
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
      document.body.style.overflow = on ? 'hidden' : '';
    });
    d.querySelectorAll('[data-ta-drawer-close]').forEach(function (x) { x.addEventListener('click', close); });
    var scrim = document.querySelector('[data-ta-scrim]');
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ============ FIT FINDER ============ */
  var W = 12.6, D = 4.7, H = 6.7;

  function fit(root) {
    if (!claim(root, 'BoundFit')) return;

    var data = [];
    var raw = root.querySelector('[data-ta-fit-data]');
    if (raw) { try { data = JSON.parse(raw.textContent); } catch (e) { data = []; } }

    var res = root.querySelector('[data-ta-fit-res]');
    var tabs = [].slice.call(root.querySelectorAll('[data-ta-fit-tab]'));
    var panels = [].slice.call(root.querySelectorAll('[data-ta-fit-panel]'));

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.remove('is-on'); });
        panels.forEach(function (p) { p.classList.remove('is-on'); });
        t.classList.add('is-on');
        var p = root.querySelector('[data-ta-fit-panel="' + t.dataset.taFitTab + '"]');
        if (p) p.classList.add('is-on');
        if (res) res.classList.remove('is-on');
      });
    });

    function show(k, title, body) {
      if (!res) return;
      res.className = 'ta-fit__res is-on ta-fit__res--' + k;
      res.innerHTML = '<h4>' + (k === 'y' ? '&#10003;' : k === 'n' ? '&#10007;' : '!') + ' ' + title + '</h4><p>' + body + '</p>' +
        (k !== 'n' ? '<button type="button" class="ta-btn" data-ta-fit-go>Get Structa</button>' : '');
      var g = res.querySelector('[data-ta-fit-go]');
      if (g) g.addEventListener('click', function () {
        var a = document.querySelector('[data-ta-atc]');
        if (a) a.scrollIntoView({ behavior: 'smooth', block: 'center' });
        else window.location.href = '/products/structa';
      });
    }

    function judge(w, d, h, label) {
      if (w >= W + 0.4 && d >= D && h >= H - 1.5) {
        show('y', 'Structa fits ' + label, 'Structa measures 12.6 by 4.7 by 6.7 inches. You have about ' + (w - W).toFixed(1) + ' inches of room to spare, so it slides in without forcing.');
      } else if (w >= W - 0.6 && d >= D - 0.8) {
        show('m', 'Snug, but it works', 'Structa measures 12.6 by 4.7 by 6.7 inches, so this one is tight. Felt gives a little and a snug fit actually holds the sides better. Our 10-day guarantee covers you either way.');
      } else {
        show('n', 'Too small for Structa', 'Structa measures 12.6 by 4.7 by 6.7 inches and needs a bag at least that wide inside. This one is smaller.');
      }
    }

    var input = root.querySelector('[data-ta-fit-input]');
    var list = root.querySelector('[data-ta-fit-list]');
    if (input && list) {
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        if (q.length < 2) { list.classList.remove('is-on'); return; }
        var hits = data.filter(function (b) { return b.name.toLowerCase().indexOf(q) > -1; }).slice(0, 7);
        if (!hits.length) {
          list.innerHTML = '<li><span>No match for that one</span><em>Try the measure tab</em></li>';
        } else {
          list.innerHTML = hits.map(function (b) {
            return '<li data-i="' + data.indexOf(b) + '"><span>' + b.name + '</span><em>' + b.w + '" x ' + b.d + '" x ' + b.h + '"</em></li>';
          }).join('');
        }
        list.classList.add('is-on');
        list.querySelectorAll('li[data-i]').forEach(function (li) {
          li.addEventListener('click', function () {
            var b = data[+li.dataset.i];
            input.value = b.name;
            list.classList.remove('is-on');
            judge(b.w, b.d, b.h, b.name);
          });
        });
      });
      root.querySelectorAll('[data-ta-fit-chip]').forEach(function (c) {
        c.addEventListener('click', function () {
          input.value = c.dataset.taFitChip;
          input.dispatchEvent(new Event('input'));
        });
      });
    }

    var mb = root.querySelector('[data-ta-fit-measure]');
    if (mb) mb.addEventListener('click', function () {
      var we = root.querySelector('[data-ta-fit-w]');
      var de = root.querySelector('[data-ta-fit-d]');
      var he = root.querySelector('[data-ta-fit-h]');
      var w = we ? parseFloat(we.value) : NaN;
      var d = de ? parseFloat(de.value) : NaN;
      var h = he ? parseFloat(he.value) : NaN;
      if (!w || !d || !h) { show('m', 'Fill in all three', 'Enter the width, depth and height of the inside of your bag.'); return; }
      judge(w, d, h, 'your bag');
    });

    root.querySelectorAll('[data-ta-fit-shape]').forEach(function (s) {
      s.addEventListener('click', function () {
        root.querySelectorAll('[data-ta-fit-shape]').forEach(function (x) { x.classList.remove('is-on'); });
        s.classList.add('is-on');
        var v = s.dataset.taFitShape;
        if (v === 'yes') show('y', 'Structa fits that shape', 'Bags in this shape have the width and depth Structa needs. It sits flat on the base and the walls reach the sides.');
        else if (v === 'maybe') show('m', 'Worth measuring first', 'Some bags in this shape fit and some are too narrow. Switch to the measure tab and check the inside width.');
        else show('n', 'Too small for Structa', 'Structa needs at least 12.6 inches of interior width. Bags in this shape are usually narrower than that.');
      });
    });
  }

  /* ============ WRITE REVIEW ============ */
  function writeReview(root) {
    if (!claim(root, 'BoundWr')) return;

    var stars = [].slice.call(root.querySelectorAll('[data-ta-wr-star]'));
    var name = root.querySelector('[data-ta-wr-name]');
    var text = root.querySelector('[data-ta-wr-text]');
    var err = root.querySelector('[data-ta-wr-err]');
    var form = root.querySelector('[data-ta-wr-form]');
    var done = root.querySelector('[data-ta-wr-done]');
    var send = root.querySelector('[data-ta-wr-send]');
    var rating = 0;

    function clearErr() { if (err) err.classList.remove('is-on'); }
    function setErr(msg) { if (err) { err.textContent = msg; err.classList.add('is-on'); } }

    stars.forEach(function (s, i) {
      s.addEventListener('click', function () {
        rating = i + 1;
        stars.forEach(function (x, n) { x.classList.toggle('is-on', n <= i); });
        clearErr();
      });
    });

    [name, text].forEach(function (f) { if (f) f.addEventListener('input', clearErr); });

    if (send) send.addEventListener('click', function () {
      if (!rating) { setErr('Pick a star rating first'); return; }
      if (!name || !name.value.trim()) { setErr('Add your name'); return; }
      if (!text || text.value.trim().length < 5) { setErr('Write a few words about your Structa'); return; }
      if (form) form.style.display = 'none';
      if (done) done.classList.add('is-on');
    });
  }

  /* ============ BOOT ============ */
  function boot() {
    document.querySelectorAll('[data-ta-offer]').forEach(function (e) {
      if (claim(e, 'BoundOffer')) { try { new Offer(e); } catch (err) { console.error('[ToteAlly] offer:', err); } }
    });
    document.querySelectorAll('[data-ta-gal]').forEach(gallery);
    document.querySelectorAll('[data-ta-baw]').forEach(baSlider);
    document.querySelectorAll('[data-ta-fit]').forEach(fit);
    document.querySelectorAll('[data-ta-wr]').forEach(writeReview);
    accordions();
    sticky();
    announcement();
    drawer();
    lowStock();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* re-run when a section is reloaded in the theme editor */
  document.addEventListener('shopify:section:load', boot);
})();